<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        
        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="updateUser">
            
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  :label="`I want to receive email communications from Wigan Athletic Football Club`"
                  v-model="clubEmail"
                  color="#0033a0"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>
                <v-switch
                  :label="`I want to receive email communications from Official Club Partners`"
                  v-model="partnerEmail"
                  color="#0033a0"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <p class="notice">You can access our preference centre at any time to opt-out of communications and control how we use your data.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  :label="`I have read and understood the Club's privacy policy`"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#0033a0"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-3>
                <p><a class="privacy-policy" href="https://wiganathletic.com/info/privacy-policy/" target="_blank">Privacy Policy</a></p>
              </v-flex>
            </v-layout>
            <v-layout row align-center mx-1 py-0>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Complete Registration</button>
            </v-layout>
          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Registration',
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      firstName: '',
      lastName: '',
      username: '',
      pass: '',
      clubEmail: false,
      partnerEmail: false,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false
    }
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },
  methods: {
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        
        var clubEmail = this.clubEmail.toString();
        var partnerEmail = this.partnerEmail.toString();
        var termsAgree = this.termsAgree.toString();
        
        var attributesList = {
            "custom:club_email": clubEmail, 
            "custom:partner_email": partnerEmail,
            "custom:privacy_accepted": termsAgree
        }
       
        this.$updateAttributes(attributesList).subscribe((response) => {
            console.log("update successful")
            if (localStorage.completeRegistrationRedirect){
              var redirect = localStorage.completeRegistrationRedirect
              console.log('redirecting to ' + localStorage.completeRegistrationRedirect)
              localStorage.removeItem('completeRegistrationRedirect')
              window.location = redirect
            } else {
              this.$router.push("/confirm");
            }   
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.success = null
            this.error = err
            this.ready = true
        });    
    }
  }
}
</script>

<style>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
  }

  
  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: #fff !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:#fafafa !important;
  }
</style>